exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".help-category{text-align:center}.help-category .icon{font-size:calc(1.33929vw + 25.71429px);margin-bottom:calc(.89286vw + 17.14286px)}", ""]);
